module.exports = __webpack_public_path__ + "static/img/lx_yellow.54f938a5.svg";